export default __webpack_public_path__ + "static/media/FRIJOL.b30f21c2.png";